 import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealAccount";

export function listAllByDealId(dealId) {
  console.log("parameter:", dealId)
  return axios({
    url: `/ws/${moduleName}/listAllByDealId/${dealId}`,
    method: 'get',
  })
}

export function updateByDealId(parameter) {
  console.log("parameter:", parameter)
  return axios({
    url: `/ws/${moduleName}/updateByDealId`,
    method: 'post',
    data: parameter
  })
}

export default {
  listAllByDealId,
  updateByDealId
}